import { emptyObject } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import { CostReviewLineItemRateShopperWithRecommendation } from './cost-review-line-item-rate-shopper-with-recommendation';
import { CostReviewLineItemShippingServiceWithRecommendation } from './cost-review-line-item-shipping-service-with-recommendation';
import CostReviewLineItemService from '../cost-review-line-item-service';

/**
 * @typedef {import('../../../prop-types/cost-review.types').CostReviewFromServiceShippingServiceRecommendationMap} CostReviewFromServiceShippingServiceRecommendationMap
 * @typedef {import('../../../prop-types/cost-review.types').CostReviewSelectedRecommendations} CostReviewSelectedRecommendations
 * @typedef {import('../../../prop-types/cost-review.types').CostReviewFromServiceRateShopperRecommendationMap} CostReviewFromServiceRateShopperRecommendationMap
 */

/**
 * @param {object} props
 * @param {ShippingServiceCostReview} props.service
 * @param {CostReviewFromServiceShippingServiceRecommendationMap} [props.shippingServiceRecommendations]
 * @param {(recommendationKey: string) => void} [props.onToggleRecommendation]
 * @param {boolean} [props.isToggleRecommendationDisabled]
 * @param {CostReviewSelectedRecommendations} [props.selectedShippingServiceRecommendations]
 * @param {CostReviewFromServiceRateShopperRecommendationMap} [props.rateShopperRecommendations]
 * @param {CostReviewSelectedRecommendations} [props.selectedRateShopperRecommendations]
 * @param {(recommendationKey: string) => void} [props.onToggleRateShopperRecommendation]
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemShippingService = ({
  service,
  shippingServiceRecommendations = emptyObject,
  onToggleRecommendation = noop,
  isToggleRecommendationDisabled = false,
  selectedShippingServiceRecommendations = emptyObject,
  rateShopperRecommendations = emptyObject,
  selectedRateShopperRecommendations = emptyObject,
  onToggleRateShopperRecommendation = noop,
}) => {
  const hasRateShopperRecommendations = rateShopperRecommendations && Object.keys(rateShopperRecommendations).length > 0;
  if (hasRateShopperRecommendations) {
    return (
      <>
        {Object.values(rateShopperRecommendations).map((recommendation) => (
          <CostReviewLineItemRateShopperWithRecommendation
            key={recommendation.key}
            isRecommendationSelected={selectedRateShopperRecommendations[recommendation.key]}
            isToggleRecommendationDisabled={isToggleRecommendationDisabled}
            onToggleRecommendation={onToggleRateShopperRecommendation}
            originalService={service}
            rateShopperRecommendation={recommendation}
          />
        ))}
      </>
    );
  }

  const hasServiceRecommendations = shippingServiceRecommendations && Object.keys(shippingServiceRecommendations).length > 0;
  if (hasServiceRecommendations) {
    return (
      <>
        {Object.values(shippingServiceRecommendations).map((recommendation) => (
          <CostReviewLineItemShippingServiceWithRecommendation
            key={recommendation.key}
            isRecommendationSelected={selectedShippingServiceRecommendations[recommendation.key]}
            isToggleRecommendationDisabled={isToggleRecommendationDisabled}
            onToggleRecommendation={onToggleRecommendation}
            originalService={service}
            shippingServiceRecommendation={recommendation}
          />
        ))}
      </>
    );
  }

  return <CostReviewLineItemService serviceCost={service.subTotal} serviceName={service.serviceName} />;
};
